export enum PostTypeItem {
    post = 'post',
    observation = 'observation',
    EYFS2021Observation = 'EYFS2021Observation',
}
